import { render, staticRenderFns } from "./SoccerJoinBookMark.vue?vue&type=template&id=a9ce45e4&scoped=true&"
import script from "./SoccerJoinBookMark.vue?vue&type=script&lang=js&"
export * from "./SoccerJoinBookMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ce45e4",
  null
  
)

export default component.exports